import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-none"
}
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "mb-0 ml-3" }
const _hoisted_7 = {
  key: 2,
  class: "my-4"
}
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "p-field-radiobutton" }
const _hoisted_10 = { for: "ActuatorSettingsMotorTypeStandardAutomatic" }
const _hoisted_11 = { class: "p-field-radiobutton" }
const _hoisted_12 = { for: "ActuatorSettingsMotorTypeStandard" }
const _hoisted_13 = { class: "p-field-radiobutton" }
const _hoisted_14 = { for: "ActuatorSettingsMotorTypePulse" }
const _hoisted_15 = { class: "my-4" }
const _hoisted_16 = { class: "my-4" }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "p-field-radiobutton" }
const _hoisted_19 = { for: "CommandSettingsOptionMonostable" }
const _hoisted_20 = { class: "p-field-radiobutton" }
const _hoisted_21 = { for: "CommandSettingsOptionBistable" }
const _hoisted_22 = { class: "p-field-radiobutton" }
const _hoisted_23 = { for: "CommandSettingsOptionBistableWithBladesControl" }
const _hoisted_24 = { class: "p-field-radiobutton" }
const _hoisted_25 = { for: "CommandSettingsOptionMonostableAndBistable" }
const _hoisted_26 = { class: "p-field-radiobutton" }
const _hoisted_27 = { for: "CommandSettingsOptionBladesAndBistable" }
const _hoisted_28 = {
  key: 4,
  class: "mt-5"
}
const _hoisted_29 = { class: "fs-12 text-right text-gray mt-3" }
const _hoisted_30 = {
  key: 5,
  class: "mt-5"
}
const _hoisted_31 = {
  key: 6,
  class: "mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Slider = _resolveComponent("Slider")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.deviceName)
      ? (_openBlock(), _createBlock("h3", _hoisted_1, _toDisplayString(_ctx.deviceName), 1))
      : _createCommentVNode("", true),
    _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.ActuatorSettings")), 1),
    (_ctx.settings.isGroupPULVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupPUL")), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.settings.hasPUL,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.settings.hasPUL = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsPULEnabled")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.settings.isGroupMotorTypeVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupMotorType")), 1),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_RadioButton, {
              id: "ActuatorSettingsMotorTypeStandardAutomatic",
              name: "shutterMode",
              value: _ctx.ShutterMotorType.StandardAutomatic,
              modelValue: _ctx.settings.shutterMotorType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.settings.shutterMotorType = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsMotorTypeStandardAutomatic")), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_RadioButton, {
              id: "ActuatorSettingsMotorTypeStandard",
              name: "shutterMode",
              value: _ctx.ShutterMotorType.Standard,
              modelValue: _ctx.settings.shutterMotorType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.settings.shutterMotorType = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsMotorTypeStandard")), 1)
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_RadioButton, {
              id: "ActuatorSettingsMotorTypePulse",
              name: "shutterMode",
              value: _ctx.ShutterMotorType.Pulse,
              modelValue: _ctx.settings.shutterMotorType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.settings.shutterMotorType = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsMotorTypePulse")), 1)
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsPulseMotorStopPulseDuration")), 1),
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.settings.stopPulseDuration,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.settings.stopPulseDuration = $event)),
              options: _ctx.settings.stopPulseDurationPickerValues,
              optionLabel: "description",
              optionValue: "value",
              class: "has--border",
              disabled: _ctx.readonly
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("p", null, _toDisplayString(_ctx.$t(
                            "AppResource.ActuatorSettingsPulseMotorUpDownPulseDuration"
                        )), 1),
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.settings.upDownPulseDuration,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.settings.upDownPulseDuration = $event)),
              options: _ctx.settings.upDownPulseDurationPickerValues,
              optionLabel: "description",
              optionValue: "value",
              class: "has--border",
              disabled: _ctx.readonly
            }, null, 8, ["modelValue", "options", "disabled"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.settings.isGroupModeVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_17, [
          _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupMode")), 1),
          _createVNode("div", _hoisted_18, [
            _createVNode(_component_RadioButton, {
              id: "CommandSettingsOptionMonostable",
              name: "shutterMode",
              value: _ctx.ShutterMode.Monostable,
              modelValue: _ctx.settings.shutterMode,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.settings.shutterMode = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionMonostable")), 1)
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_RadioButton, {
              id: "CommandSettingsOptionBistable",
              name: "shutterMode",
              value: _ctx.ShutterMode.Bistable,
              modelValue: _ctx.settings.shutterMode,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.settings.shutterMode = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionBistable")), 1)
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode(_component_RadioButton, {
              id: "CommandSettingsOptionBistableWithBladesControl",
              name: "shutterMode",
              value: _ctx.ShutterMode.BistableWithBladesControl,
              modelValue: _ctx.settings.shutterMode,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.settings.shutterMode = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t(
                            "AppResource.CommandSettingsOptionBistableWithBladesControl"
                        )), 1)
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode(_component_RadioButton, {
              id: "CommandSettingsOptionMonostableAndBistable",
              name: "shutterMode",
              value: _ctx.ShutterMode.MonostableBistable,
              modelValue: _ctx.settings.shutterMode,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.settings.shutterMode = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionMonostableAndBistable")), 1)
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode(_component_RadioButton, {
              id: "CommandSettingsOptionBladesAndBistable",
              name: "shutterMode",
              value: _ctx.ShutterMode.BladesAndBistable,
              modelValue: _ctx.settings.shutterMode,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.settings.shutterMode = $event)),
              disabled: _ctx.readonly
            }, null, 8, ["value", "modelValue", "disabled"]),
            _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionBladesAndBistable")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.settings.isGroupPresetVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_28, [
          _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupPreset")), 1),
          _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsPresetValue")), 1),
          _createVNode(_component_Slider, {
            modelValue: _ctx.settings.presetValue,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.settings.presetValue = $event)),
            orientation: "horizontal",
            disabled: _ctx.readonly
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode("div", _hoisted_29, _toDisplayString(_ctx.settings.presetValue), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.settings.isGroupStopTimeTypeVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_30, [
          _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupStopTime")), 1),
          _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsPickerStopTime")), 1),
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.settings.stopTime,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.settings.stopTime = $event)),
            options: _ctx.settings.stopTimePickerValues,
            optionLabel: "description",
            optionValue: "value",
            class: "has--border",
            disabled: _ctx.readonly
          }, null, 8, ["modelValue", "options", "disabled"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.settings.isGroupDelayBetweenDoorsVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_31, [
          _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupDelayBetweenDoors")), 1),
          _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsPickerDelayBetweenDoors")), 1),
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.settings.delayBetweenDoorsTime,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.settings.delayBetweenDoorsTime = $event)),
            options: _ctx.settings.delayBetweenDoorsTimePickerValues,
            optionLabel: "description",
            optionValue: "value",
            class: "has--border",
            disabled: _ctx.readonly
          }, null, 8, ["modelValue", "options", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}